/**
 * One report, which can be calculated by server.
 */
export interface ReportContract {
  id: number;
  keyword: string;
  title: string;
  type: string;
}
